if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const quantityInput = this.quantityInput;
        const cartQuantity = quantityInput?.dataset.cartQuantity
          ? parseInt(quantityInput.dataset.cartQuantity, 10)
          : 0;
        const shouldUpdateExistingCart =
          quantityInput?.dataset.cartSyncEnabled === 'true' && cartQuantity > 0;

        if (shouldUpdateExistingCart) {
          this.updateSyncedCartQuantity(evt, quantityInput);
          return;
        }

        if (quantityInput) {
          const quantity = parseInt(quantityInput.value, 10);
          const min = quantityInput.min ? parseInt(quantityInput.min, 10) : 1;
          const max = quantityInput.max ? parseInt(quantityInput.max, 10) : null;

          if (
            quantityInput.disabled ||
            Number.isNaN(quantity) ||
            quantity < min ||
            (max !== null && quantity > max)
          ) {
            return;
          }
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const giftWrapValue = formData.get('properties[包装]');
        const allowsNoshi = giftWrapValue === '包装・内のし' || giftWrapValue === '包装・外のし';

        if (!allowsNoshi) {
          formData.delete('properties[かけ紙（のし）]');
          formData.delete('properties[表書き区分]');
          formData.delete('properties[表書き]');
          formData.delete('properties[名入れ]');
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            this.error = false;

            // カートへの追加が成功したら、ドロワー/通知ポップアップは表示せず
            // 必ずカートページへ遷移する（テーマ設定のカートの種類に依存しない）
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });

            window.location = window.routes.cart_url;
            return;
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      updateSyncedCartQuantity(evt, quantityInput) {
        const quantity = parseInt(quantityInput.value, 10);
        const min = quantityInput.min ? parseInt(quantityInput.min, 10) : 0;
        const max = quantityInput.max ? parseInt(quantityInput.max, 10) : null;
        const variantId = this.variantIdInput.value;

        if (
          !variantId ||
          Number.isNaN(quantity) ||
          quantity < min ||
          (max !== null && quantity > max)
        ) {
          return;
        }

        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const body = JSON.stringify({ id: variantId, quantity });

        fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body })
          .then((response) => response.json())
          .then((cartData) => {
            if (cartData.errors) throw new Error(cartData.errors);

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: variantId,
              cartData,
            });

            window.location = window.routes.cart_url;
          })
          .catch((error) => {
            console.error(error);
            this.handleErrorMessage(window.cartStrings.error);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            CartPerformance.measureFromEvent('cart-sync:user-action', evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      get quantityInput() {
        return (
          this.form.elements.namedItem('quantity') ||
          this.closest('product-info')?.querySelector('.product-form__quantity [name="quantity"]')
        );
      }
    }
  );
}
